import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { UploadPersonalFilesComponent } from './upload-personal-files';

export const UploadPersonalFilesModule: string = ng
    .module('upload-personal-files', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('uploadPersonalFiles', UploadPersonalFilesComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/upload-personal-files/upload-personal-files.module.ts